export const STORAGE_KEY = 'patrimoffice-cgpi'



// WEBPACK FOOTER //
// ./src/store/state.js